import generateCrudConstants from './baseCrudConstants';
import mirrorCreator from 'mirror-creator';

export default {
  ...mirrorCreator([
    'FETCH_EVENT_ELIGIBILITY_REQUEST',
    'FETCH_EVENT_ELIGIBILITY_SUCCESS',
    'FETCH_EVENT_ELIGIBILITY_ERROR'
  ]),
  ...generateCrudConstants('PUBLISHERS', 'R')
};



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/constants/publishersConstants.js